import type { MaybeRefOrGetter, Ref } from "vue";

import { inject, onBeforeUnmount, reactive, toRef, watch } from "vue";

import { _validationObserverKey } from "@/lib/validation/ValidationObserver/useValidationObserver";

function useObserverInject(
  name: Ref<string>,
  validationProviderId: string,
  modelValue: MaybeRefOrGetter<unknown>,
  validateAll: () => Promise<void>,
  blockingRulesValid: Ref<boolean>,
  isValidating: Ref<boolean>,
) {
  const validationObserver = inject(_validationObserverKey, null);

  validationObserver?.addProvider(
    validationProviderId,
    reactive({ name, validateAll, blockingRulesValid, isValidating }),
  );

  onBeforeUnmount(() => {
    validationObserver?.deleteProvider(validationProviderId);
  });

  watch(
    toRef(modelValue),
    () => {
      validationObserver?.resetServerSideErrors(name.value);
    },
    { deep: true },
  );
}
export { useObserverInject };
